import { lazy } from 'react';

// Lazy load route components
export const PDFPreview = lazy(() => import('../features/chat/components/PDFPreview'));

export const Onboarding = lazy(() => import('../features/auth/onboarding/Onboarding'));
export { default as MainInterface } from '../components/layout/MainInterface';
export const AdminPanel = lazy(() => import('../features/admin/AdminPanel'));
export const WelcomeAnimationTest = lazy(() => import('../features/auth/onboarding/WelcomeAnimationTest'));
export const PaymentPage = lazy(() => import('../features/auth/onboarding/PaymentPage'));